<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" v-show="isModalVisible">
      <div class="modal-dimmer" @click="closeModalBackdrop"></div>
			<component :is="modal_payload.name" :payload="modal_payload" @close="closeModal" @set:persistent="setPersistent"></component>
    </div>
  </transition>
</template>

<script>
  import AlertCreated from './modals/AlertCreated';
  import ApplingForJob from './modals/ApplingForJob';
  import EditSavedSearchAlert from './modals/EditSavedSearchAlert';
  import SignIn from './modals/SignIn';
  import EscapeScore from './modals/EscapeScore';
  import Video from './modals/Video';
	import VideoShort from './modals/VideoShort';
	import OrgCompare from './modals/OrgCompare';
  import RecommendedOrgs from './modals/RecommendedOrgs';

  export default {
    name: 'ModalManager',

    components: {
      AlertCreated,
      ApplingForJob,
      EditSavedSearchAlert,
      SignIn,
      EscapeScore,
      Video,
			VideoShort,
			OrgCompare,
      RecommendedOrgs
    },

    props: {
    	login_url: {
    		type: String
    	},
			preferences_url: {
				type: String
			}
    },

    emits: [],

    data() {
      return {
        modal_payload: false,
        persistent: true
      }
    },

    created() {
			this.emitter.on('openModal', this.openModal);
		},

    mounted() {

    },

		beforeUnmount() {
			this.emitter.off('openModal');
		},

    methods: {
      closeModal() {
				console.log("Closing Modal");
        this.modal_payload = false;
      },
      openModal(payload) {
        if (payload.persistent !== undefined) {
          this.persistent = payload.persistent;
        }
        if (payload.name == 'SignIn') {
        	payload.url = this.login_url;
					payload.preferences_url = this.preferences_url;
        }
				console.log("Opening Modal", payload);
        this.modal_payload = payload;
      },
      closeModalBackdrop() {
        if (!this.persistent) {
          this.closeModal();
        }
      },
			setPersistent(value) {
				this.persistent = value;
			}
    },

    computed: {
      isModalVisible() {
      	return (this.modal_payload);
      }
    }
  };
</script>
